import { render } from "./QRCodeCheck.vue?vue&type=template&id=2c4f3f74"
import script from "./QRCodeCheck.vue?vue&type=script&lang=js"
export * from "./QRCodeCheck.vue?vue&type=script&lang=js"

import "./QRCodeCheck.vue?vue&type=style&index=0&id=2c4f3f74&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__